// Single source of truth for the `tenants` row projection shared by the server
// loader (get-tenant-row.ts, server-only) and fetchTenantConfig (queries.ts,
// client-importable). This module MUST stay neutral — no
// 'server-only' / 'use client' directive and no imports — so both the server and
// client bundles can consume it.
//
// Why it exists: fetchTenantConfig accepts an optional prefetched tenant row
// (from getTenantRow). deriveShellModuleState gates paid-module entitlement off
// the row's shape, so the prefetched path and fetchTenantConfig's own cold SELECT
// MUST return the identical column set. Deriving both from this one constant makes
// divergence impossible (previously two hand-kept literals — 2026-07-02 audit).
export const TENANT_ROW_COLUMNS =
  'id, name, abn, legal_name, registration_type, registration_id, address, phone, email, website, logo_url, brand_config, subscription_tier, billing_plan, selected_packages, subscription_status, is_active, is_demo, created_at, updated_at';
